import style from '../styles/form.module.css'

import { getLayout, LayoutContext } from './sg/Layout'
import useTranslation from 'next-translate/useTranslation'
import classNames from 'classnames/bind'
import { useContext, useRef, useState } from 'react'
import useAuth from '../hooks/useAuth'
import enums from '../data/enums.json'
import DateSelect from '../components/DateSelect'
import { useRouter } from 'next/router'

const { Occupations, Industries, DocumentTypes } = enums

export default function IDUpload ({ onSubmit, onError, onSuccess, withBirthDate }) {
  const uploadFormElem = useRef()
  const fileElem = useRef()
  const fileBackElem = useRef()
  const documentIdElem = useRef()
  const documentTypeElem = useRef()
  const occupationElem = useRef()
  const industryElem = useRef()
  const [expiry, setExpiry] = useState()

  const router = useRouter()
  const { t } = useTranslation('main')
  const locale = router.locale
  const c = classNames.bind(style)
  const { authToken, authType } = useAuth()
  const [birthDate, setBirthDate] = useState('')
  const [idType, setIdType] = useState('Passport')

  // eslint-disable-next-line no-unused-vars
  const [layoutContext, setLayoutContext] = useContext(LayoutContext)

  const handleUploadSubmit = async e => {
    e.preventDefault()
    uploadFormElem.current.removeAttribute('novalidate')
    if (uploadFormElem.current.reportValidity()) {
      setLayoutContext({})
      onSubmit && onSubmit()

      const data = new window.FormData()
      data.append('industry', industryElem.current.value)
      data.append('occupation', occupationElem.current.value)
      data.append('documentType', documentTypeElem.current.value)
      data.append('documentId', documentIdElem.current.value)
      data.append('documentExpiry', expiry)
      data.append('file', fileElem.current.files[0])
      if (birthDate) {
        data.append('birthDate', birthDate)
      }

      const responsePromise = window.fetch('/api/upload', {
        method: 'POST',
        mode: 'same-origin',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          Authorization: `${authType} ${authToken}`
        },
        redirect: 'error',
        referrerPolicy: 'no-referrer',
        body: data
      })

      let responseBackPromise
      if (documentTypeElem.current.value === 'GovID' && fileBackElem.current.files[0]) {
        data.set('file', fileBackElem.current.files[0])
        data.set('documentType', 'GOVIDB')
        responseBackPromise = window.fetch('/api/upload', {
          method: 'POST',
          mode: 'same-origin',
          cache: 'no-cache',
          credentials: 'same-origin',
          headers: {
            Authorization: `${authType} ${authToken}`
          },
          redirect: 'error',
          referrerPolicy: 'no-referrer',
          body: data
        })
      } else {
        responseBackPromise = Promise.resolve({ ok: true })
      }
      const [response, responseBack] = await Promise.all([responsePromise, responseBackPromise])

      if (response.ok && responseBack.ok) {
        onSuccess && onSuccess()
      } else {
        setLayoutContext({ message: t('upload-unknown-error') })
        onError && onError()
      }
    }
  }

  return (
    <form noValidate ref={uploadFormElem} id='uploadform' onSubmit={handleUploadSubmit} className={c('upload')}>
      <h3>{t('upload-upload-title')}</h3>
      <div className={c('inputfield')}>
        <label htmlFor='documentType'>{t('upload-documenttype-label')}</label>
        <select id='documentType' required ref={documentTypeElem} onChange={e => setIdType(e.target.value)}>
          <option value='' disabled>{t('upload-documenttype-placeholder')}</option>
          {DocumentTypes.map(t => <option key={t} value={t}>{t}</option>)}
        </select>
      </div>
      <div className={c('inputfield')}>
        <input type='text' ref={documentIdElem} id='documentid' required minLength={4} placeholder={t('upload-documentid-placeholder')} onChange={e => { e.target.setCustomValidity('') }} />
      </div>
      <div className={c('inputfield')}>
        <label>{idType === 'Passport' ? t('upload-expiry-label') : t('upload-expiry-optional-label')}</label>
        <DateSelect inTheFuture required={idType === 'Passport'} onChange={e => { setExpiry(e.target.value); e.target.setCustomValidity('') }} locale={locale} />
      </div>
      <div className={c('inputfield')}>
        <label htmlFor='file'>{idType === 'GovID' ? t('upload-document-front-label') : t('upload-document-label')}</label>
        <input type='file' ref={fileElem} id='file' required accept='image/*' capture='environment' onChange={e => { e.target.setCustomValidity('') }} />
        {idType === 'GovID' && (
          <>
            <label htmlFor='fileBack'>{t('upload-document-back-label')}</label>
            <input type='file' ref={fileBackElem} id='fileBack' accept='image/*' capture='environment' onChange={e => { e.target.setCustomValidity('') }} />
          </>
        )}
      </div>
      <div className={c('inputfield')}>
        <label htmlFor='occupation'>{t('upload-occupation-label')}</label>
        <select id='occupation' required defaultValue='' ref={occupationElem}>
          <option value='' disabled>{t('upload-occupation-placeholder')}</option>
          {Occupations.map(t => <option key={t} value={t}>{t}</option>)}
        </select>
      </div>
      <div className={c('inputfield')}>
        <select id='industry' required defaultValue='' ref={industryElem}>
          <option value='' disabled>{t('upload-industry-placeholder')}</option>
          {Industries.map(t => <option key={t} value={t}>{t}</option>)}
        </select>
      </div>
      {withBirthDate && (
        <div className={c('inputfield')}>
          <label>{t('upload-birthdate')}</label>
          <DateSelect required onChange={e => { setBirthDate(e.target.value); e.target.setCustomValidity('') }} locale={locale} />
        </div>
      )}
      <br />
      <button type='submit'>{t('upload-uploadbutton')}</button>
      <br /><br />
    </form>
  )
}

IDUpload.getLayout = getLayout
